<template>
  <div class="litigant">
    <Row class="detail-header">
      <span>对方当事人</span>
      <Row v-if="allowEdit" class="add-btn">
        <Button type="primary" @click="openAdd">新增对方当事人</Button>
      </Row>
    </Row>
    <!-- <Row class="table-box" style="margin-bottom:16px;">
      <Table :columns="changeColumns('pass')" :loading="tableLoading" :data="passData" />
    </Row>
    <Row class="detail-header">
      <span>对方当事人（待确认）</span>
    </Row>
    <Row class="table-box">
      <Table :columns="changeColumns('unConfirm')" :loading="tableLoading" :data="unauditData" />
    </Row> -->

    <Row>
      <Col
        v-for="(item,index) in tableData" :key="index"
        span="10" :offset="1"
        style="margin-bottom: 20px; "
      >
        <litigant-list
          :list-data="item"
          @emitData="emitData"
          @rowOption="rowOption"
          @getDetail="getDetail"
        />
      </Col>
    </Row>

    <!-- 删除modal -->
    <Modal
      v-model="optionCtrl"
      :title="'确定'+modalTitle"
      :width="360"
      :footer-hide="true"
    >
      <Row v-if="modalTitle=='同步工商信息'" class="modal-tips">是否确认同步对方当事人工商信息？</Row>

      <Row v-else class="modal-tips">请问是否{{ modalTitle }}此对方当事人？</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="optionConfrim"
        >确认</Button>
        <Button style="margin-left: 8px" @click="optionCtrl=false;">取消</Button>
      </Row>
    </Modal>

    <Modal

      v-model="infoDrawerCtrl"
      :title="isAdd?(detailData.id?'编辑对方当事人':'新增对方当事人'):'对方当事人详情'"
      :width="(isAdd || !hasBussiness)?600:'90%'"
      :footer-hide="true"
    >
      <Row v-if="!isAdd&&hasBussiness&&infoDrawerCtrl">
        <business-information :default-obj="detailData">
          <div slot="info-content" style="max-width:1200px;">
            <tort-subject-info
              :tort-category="clueDetail.tortCategory" :default-data="detailData"
              :identify-show="true"
            />
          </div>
        </business-information>
      </Row>
      <Row v-if="!isAdd&&!hasBussiness&&infoDrawerCtrl">
        <tort-subject-info
          :tort-category="clueDetail.tortCategory" :default-data="detailData"
          :double="false" :identify-show="true"
        />
      </Row>
      <Row v-if="isAdd&&infoDrawerCtrl" class="detail-form">
        <tort-subject-form
          ref="tortSubjectDom" :label-width="110"
          :default-data="detailData" :identify-show="true"
          :tort-category="clueDetail.tortCategory" :channel-type="clueDetail.channelType"
          @getList="getTortList"
        />
        <Row class="detail-btn-box">
          <Button
            type="primary" style="margin-right:10px;"
            :disabled="isSubmit" @click="validConflict"
          >保存</Button>
          <Button @click="infoDrawerCtrl=false">取消</Button>
        </Row>
      </Row>
    </Modal>

    <Modal
      v-model="tipsCtrl"
      title="冲突确认"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">当前对方当事人信息疑似冲突，是否继续提交？</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          :loading="isSubmit" @click="submitNew"
        >确认</Button>
        <Button style="margin-left: 8px" @click="tipsCtrl=false;">取消</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
import tortSubjectForm from '@/view/clue/myClue/plugin/tortSubjectForm.vue'
import tortSubjectInfo from '@/view/clue/myClue/plugin/tortSubjectInfo.vue'
import litigantList from '@/view/clue/myClue/plugin/litigantList.vue'
import businessInformation from '@/components/common/businessInformation/businessInformation.vue'
export default {
  components: {
    tortSubjectForm,
    tortSubjectInfo,
    businessInformation,
    litigantList
  },
  props: ['caseId', 'clueId', 'projectId', 'allowEdit', 'snapShot', 'clueDetail'],
  data () {
    return {
      styles: styles,
      modalTitle: '',
      modalType: '',
      activeObj: {},
      optionCtrl: false,
      tableLoading: false,
      isSubmit: false,
      infoDrawerCtrl: false,
      isAdd: false,
      id: '',
      formData: {},
      formValidate: {
        auditRemark: ''
      },
      tableData: [],
      detailData: {},
      hasBussiness: false,
      tipsCtrl: false
    }
  },
  computed: {
    passData() {
      if (!this.tableData || this.tableData.length === 0) { return [] }
      return this.tableData.filter((item, index) => {
        // P 待审核   E 已审核   R 驳回
        return item.auditState === 'E'
      })
    },
    unauditData() {
      if (!this.tableData || this.tableData.length === 0) { return [] }
      return this.tableData.filter((item, index) => {
        // P 待审核   E 已审核   R 驳回
        return item.auditState !== 'E'
      })
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getData()
  },
  updated() {},
  methods: {
    emitData(key, val) {
      this[key] = val
      console.log(this[key], 22)
      console.log(this.id, 333)
    },

    changeColumns(type) {
      const columnsObj = {
        name: {
          title: '主体名称',
          key: 'name',
          width: 250,
          render: (h, params) => {
            const spanDom = h('span', {
              style: {
                color: styles.globalMainColor,
                cursor: 'pointer',
                display: 'inline-block',
                maxWidth: '210px'
              },
              class: 'textover',
              attrs: { title: params.row.name },
              on: {
                click: () => {
                  this.activeObj = params.row
                  this.isAdd = false
                  this.getDetail()
                }
              }
            }, params.row.name)
            const conTextList = []
            if ((params.row.abnormalData && params.row.abnormalData.abnormal !== 'M') || params.row.abnormalCode) {
              const txt1 = params.row.abnormalData.abnormal
              if (txt1 && txt1 !== 'M') {
                if (txt1 === 'C') {
                  conTextList.push(h('p', '该主体已注销，请尽快核实'))
                } else if (txt1 === 'N') {
                  conTextList.push(h('p', '查询不到该主体'))
                } else {
                  conTextList.push(h('p', '异常'))
                }
              }
              if (params.row.abnormalCode) {
                // console.log(params.row.abnormalCode)
                const txt2 = params.row.abnormalCode
                if (txt2.indexOf('B') !== -1) {
                  conTextList.push(h('p', '缺少主体区域信息'))
                }
                if (txt2.indexOf('C') !== -1) {
                  conTextList.push(h('p', '缺少工商登记地址信息'))
                }
                if (txt2.indexOf('D') !== -1) {
                  conTextList.push(h('p', '缺少法人/经营者信息'))
                }
                if (txt2.indexOf('E') !== -1) {
                  conTextList.push(h('p', '缺少信用代码信息'))
                }
                if (txt2.indexOf('F') !== -1) {
                  conTextList.push(h('p', '缺少联系方式'))
                }
              }
            }
            const contentDom = h('div', { slot: 'content' }, conTextList)
            const abnormalIcon = h('span', {
              class: 'icon-doubt-01',
              style: {
                'fontSize': '16px',
                'color': '#D71515'
              }
            })
            const tipDom = h('Tooltip', {
              transfer: true,
              props: { placement: 'bottom', trigger: 'hover', theme: 'light' }
            }, [abnormalIcon, contentDom])
            return conTextList.length !== 0 ? [spanDom, tipDom] : spanDom
          }
        },
        categoryName: {
          title: '主体类型',
          key: 'categoryName'
        },
        propertyName: {
          title: '经营性质',
          key: 'propertyName'
        },
        provinceName: {
          title: '主体区域',
          key: 'provinceName',
          render: (h, params) => {
            const str = `${params.row.provinceName || ''}${params.row.cityName || ''}${params.row.areaName || ''}`
            const strDom = h('span', {
              class: ['textover'],
              attrs: { title: str }
            }, str)
            return strDom
          }
        },
        auditRemark: {
          title: '审核备注',
          key: 'auditRemark',
          render: (h, params) => {
            const strDom = h('span', {
              class: ['textover'],
              attrs: { title: params.row.auditRemark }
            }, params.row.auditRemark)
            return strDom
          }
        },
        auditState: {
          title: '状态',
          width: 100,
          key: 'auditState',
          render: (h, params) => {
            let color
            const state = params.row.auditState
            switch (true) {
              case state === 'P':color = 'warningColor'; break
              case state === 'E':color = 'successColor'; break
              case state === 'R':color = 'errorColor'; break
            }
            return h('Tag', {
              class: 'textover',
              attrs: {
                title: params.row.auditStateName,
                color: styles[color]
              },
              style: {
                borderRadius: '11px'
              }
            }, params.row.auditStateName)
          }
        },
        operate: {
          title: '操作',
          key: 'operate',
          width: 80,
          render: (h, params) => {
            if (!this.allowEdit || !params.row.status) {
              return h('span', '')
            }
            const editButton = h('span', {
              class: ['icon-edit-01'],
              attrs: { title: '修改' },
              style: {
                fontSize: '14px',
                marginRight: '8px',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.rowOption(params.row, 'edit')
                }
              }
            })
            const deleteButton = h('span', {
              class: ['icon-trash-01'],
              attrs: { title: '删除' },
              style: {
                fontSize: '14px',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.rowOption(params.row, 'delete')
                }
              }
            })
            const btnList = []
            btnList.push(editButton)
            btnList.push(deleteButton)
            return btnList
          }
        }
      }
      if (type === 'pass') {
        delete columnsObj.auditRemark
      }
      const columns = []
      for (const key in columnsObj) {
        columns.push(columnsObj[key])
      }
      return columns
    },
    getData() {
      let url = ''
      if (this.snapShot) {
        url = '/business/litigants/lawyer/snapshot'
      } else {
        url = '/business/litigants/lawyer'
      }
      const ajaxData = { caseId: this.caseId }
      this.tableLoading = true
      this.$get(url, ajaxData).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableLoading = false
          this.tableData = res.data.map(item => {
            this.$set(item, 'abnormalData', {})
            return item
          })
          // console.log(this.tableData, ' this.tableData')

          // 判断是否有企业
          const bool = this.tableData.some(item => item.property !== 'P')

          if (this.tableData.length !== 0 && bool) {
            this.getAbnormalData()
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getDetail() {
      let url = ''
      if (this.snapShot) {
        url = '/business/litigant/lawyer/snapshot/' + this.activeObj.id
      } else {
        url = '/business/litigant/' + this.activeObj.id + '/lawyer'
      }
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.detailData = res.data
          this.detailData.cityList = [res.data.province, res.data.city, res.data.area]
          // 判断是否有统一信用代码，如果有信用代码则用信用代码查询工商信息，否则用名称查询工商信息
          if (this.isAdd) {
            this.infoDrawerCtrl = true
            return
          }
          if (this.detailData.creditCode && this.detailData.creditCode.trim()) {
            this.hasBussiness = true
            this.infoDrawerCtrl = true
          } else {
            this.hasBussiness = false
            this.getBusinessInfo(res.data.name)
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 获取当事人异常信息
    getAbnormalData() {
      const url = '/business/abnormal/litigant'
      let ids = []
      this.tableData.forEach(item => {
        if (item.property !== 'P') {
          const idArr = item.id
          ids = ids.concat(idArr)
        }
      })
      this.$post(url, ids).then(res => {
        if (res.code === 0) {
          this.tableData.forEach(item => {
            res.data.forEach(i => {
              if (i.name === item.name) {
                item.abnormalData = {
                  name: i.name,
                  abnormal: i.abnormal,
                  submitTime: i.submitTime
                }
              }
            })
          })
        }
      })
    },
    rowOption(obj, type) {
      this.modalType = type
      this.activeObj = obj
      switch (type) {
        case 'edit':
          this.isAdd = true
          this.getDetail()
          break
        case 'delete':
          if (this.passData.length <= 1 && obj.auditState === 'E') {
            this.$Message.error('至少保留一条已确认的当事人信息')
            return
          }
          this.modalTitle = '删除'
          this.optionCtrl = true
          break
      }
    },
    openAdd() {
      this.detailData = {}
      this.isAdd = true
      this.infoDrawerCtrl = true
    },
    optionConfrim() {
      if (this.modalTitle == '同步工商信息') {
        const url = '/business/litigants/syncFullDimensionalData'
        const ajaxData = { litigantId: this.id }
        this.isSubmit = true

        this.$get(url, ajaxData).then(res => {
          this.isSubmit = false
          if (res.code === 0) {
            this.$Message.success('操作成功')
            this.getData()
            this.optionCtrl = false
            this.infoDrawerCtrl = false
          } else {
            this.$Message.error(res.message)
          }
        })
      } else {
        const url = '/business/litigant/' + this.id + '/lawyer'
        const ajaxData = { id: this.id }
        this.isSubmit = true

        this.$del(url, ajaxData).then(res => {
          this.isSubmit = false
          if (res.code === 0) {
            this.$Message.success('操作成功')
            this.getData()
            this.optionCtrl = false
            this.infoDrawerCtrl = false
          } else {
            this.$Message.error(res.message)
          }
        })
      }
    },
    // 验证对方当事人是否冲突
    validConflict() {
      const url = '/business/litigant/check-conflict'
      const flag = this.$refs['tortSubjectDom'].submitValid()
      const item = this.formData
      if (!flag) {
        return
      }
      const ajaxData = {
        caseId: this.caseId,
        clueId: this.clueId,
        projectId: this.projectId,
        tortItems: [{
          category: item.category,
          name: item.name
        }]
      }
      this.isSubmit = true
      // 0无冲突无关联 || 1有冲突 || 2有关联 || 3有冲突有关联
      this.$get(url, ajaxData).then(res => {
        this.isSubmit = false
        if (res.code === 0) {
          if (res.data === 0 || res.data === 2) {
            this.submitNew()
          } else if (res.data === 1 || res.data === 3) {
            this.tipsCtrl = true
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    submitNew() {
      this.tipsCtrl = false
      let url
      const item = this.formData
      const ajaxData = {
        caseId: this.caseId,
        category: item.category,
        name: item.name,
        creditCode: item.creditCode,
        legalIdNo: item.legalIdNo,
        legalRepresentative: item.legalRepresentative,
        province: item.province,
        property: item.property,
        city: item.city,
        area: item.area,
        address: item.address,
        contact: item.contact,
        attachmentList: item.attachmentList,
        identifyRemark: item.identifyRemark,
        platformOrderNo: item.platformOrderNo
      }
      if (item.category === 'S') {
        ajaxData.type = item.type
      }
      this.isSubmit = true
      if (JSON.stringify(this.detailData) !== '{}') {
        url = '/business/litigant/' + this.detailData.id + '/lawyer'
        ajaxData.id = this.detailData.id
        this.$patch(url, ajaxData).then(res => {
          this.isSubmit = false
          if (res.code === 0) {
            this.$Message.success('操作成功')
            this.getData()
            this.infoDrawerCtrl = false
          } else {
            this.$Message.error(res.message)
          }
        })
      } else {
        url = '/business/litigant/lawyer'
        this.$post(url, ajaxData).then(res => {
          this.isSubmit = false
          if (res.code === 0) {
            this.$Message.success('操作成功')
            this.getData()
            this.infoDrawerCtrl = false
          } else {
            this.$Message.error(res.message)
          }
        })
      }
    },
    getTortList(data) {
      this.formData = data
    },
    getBusinessInfo(name) {
      const url = '/base/company/one-company-information'
      const ajaxData = {
        companyName: name
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.hasBussiness = res.data
          }
          this.infoDrawerCtrl = true
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import './../../assets/globalStyle.scss';
.litigant{
    margin:10px;
    .detail-header{
        background: #fff;
        padding:5px 0 5px 10px;
        &::before{
            left:0;
        }
    }
    .add-btn{
        float: right;
    }
    .table-box{
        border:1px solid #dcdee2;
        border-bottom:0;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/case/litigant.vue